import React, { ReactElement } from 'react';

import { useCompany } from 'hooks/use-selector';

import './company-view-presell.desktop.scss';

const CompanyViewPresellDesktop: React.FC = (): ReactElement | null => {
    const company = useCompany();

    if (!company.presell) {
        return null;
    }

    return (
        <div className="container">
            <div className="company-view__presell">
                {company.presell?.map((paragraph): ReactElement => (
                    <p key={paragraph} className="company-view__presell-paragraph" dangerouslySetInnerHTML={{ __html: paragraph }}/>
                ))}
            </div>
        </div>
    );
};

export default CompanyViewPresellDesktop;
